<template>
  <gc-main-layout
    :title="title"
    :isXSmall="isXSmall"
    :isLarge="isLarge"
    :baseView="baseView"
    :key="baseView.mode"
    :backButtonEnable="true"
    :backButtonFunction="backButtonFunction"
    :formsConfig="formsConfig"
  >
    <template #headerContent>
      <GcHeaderContentStatic :title="reportTitle" v-if="reportTitle" />
    </template>

    <div class="grid-report">
      <gc-filter-split-view
        :showLeftContainer="showLeftContainer"
        :showRightContainer="showRightContainer"
      >
        <template #leftContent>
          <dx-data-grid
            :data-source="dataSourceConfig"
            :allow-column-reordering="true"
            :reshape-on-push="true"
            :columns="columns"
            @toolbar-preparing="onToolbarPreparing($event)"
            :height="gridHeight"
            :column-chooser="{
              enabled: true,
              allowSearch: true,
              mode: 'select',
              height: '100%',
              width: 300,
            }"
            v-if="loadingCompleted"
            @content-ready="listContentReady"
            ref="grid-report-grid"
          >
            <DxExport :enabled="true" :file-name="saveFileName" />
            <DxGroupPanel :visible="true" />
            <DxGrouping :auto-expand-all="false" />

            <DxSummary v-if="columnSummary">
              <DxGroupItem
                v-for="item in columnSummary"
                :key="item['id']"
                :column="item['column']"
                :summary-type="item['summary-type']"
                :value-format="item['value-format']"
                :display-format="item['display-format']"
                :show-in-group-footer="item['show-in-group-footer']"
                :align-by-column="item['align-by-column']"
                :show-in-column="item['show-in-column']"
              />
            </DxSummary>

            <template #customer-group-cell-template="{ data }">
              <GcDescriptionCodeCellTemplate
                :description="data.data.CustomerGroupName"
                :code="data.data.CustomerGroupCode"
              />
            </template>

            <template #customer-type-cell-template="{ data }">
              <GcDescriptionCodeCellTemplate
                :description="data.data.CustomerTypeName"
                :code="data.data.CustomerTypeCode"
              />
            </template>

            <template #customer-cell-template="{ data }">
              <GcDescriptionCodeCellTemplate
                :description="data.data.CustomerName"
                :code="data.data.CustomerCode"
              />
            </template>

            <template #branch-cell-template="{ data }">
              <GcDescriptionCodeCellTemplate
                :description="data.data.BranchName"
                :code="data.data.BranchCode"
              />
            </template>
            <template #division-cell-template="{ data }">
              <GcDescriptionCodeCellTemplate
                :description="data.data.DivisionName"
                :code="data.data.DivisionCode"
              />
            </template>

            <template #category-1-cell-template="{ data }">
              <GcDescriptionCodeCellTemplate
                :description="data.data.ProdCat1Name"
                :code="data.data.ProdCat1Code"
              />
            </template>

            <template #category-2-cell-template="{ data }">
              <GcDescriptionCodeCellTemplate
                :description="data.data.ProdCat2Name"
                :code="data.data.ProdCat2Code"
              />
            </template>

            <template #category-3-cell-template="{ data }">
              <GcDescriptionCodeCellTemplate
                :description="data.data.ProdCat3Name"
                :code="data.data.ProdCat3Code"
              />
            </template>

            <template #category-4-cell-template="{ data }">
              <GcDescriptionCodeCellTemplate
                :description="data.data.ProdCat4Name"
                :code="data.data.ProdCat4Code"
              />
            </template>

            <template #sales-rep-cell-template="{ data }">
              <GcDescriptionCodeCellTemplate
                :description="data.data.OrderSalesRepName"
                :code="data.data.OrderSalesRepCode"
              />
            </template>
            <template #drop-code-cell-template="{ data }">
              <GcDescriptionCodeCellTemplate
                :description="data.data.DropName"
                :code="data.data.DropCode"
              />
            </template>

            <template #customer-rep-cell-template="{ data }">
              <GcDescriptionCodeCellTemplate
                :description="data.data.CustomerSalesRepName"
                :code="data.data.CustomerSalesRepCode"
              />
            </template>
            <template #item-cell-template="{ data }">
              <GcDescriptionCodeCellTemplate
                :description="data.data.ItemName1"
                :code="data.data.ItemCode"
              />
            </template>

            <template #product-type-cell-template="{ data }">
              <GcDescriptionCodeCellTemplate
                :description="data.data.ProdTypeName"
                :code="data.data.ProductTypeCode"
              />
            </template>

            <template #groupHeaderTemplate="{ data }">
              <div
                class="informer"
                v-if="
                  (model.CurrentDateGroup == 'Day' ||
                    model.CurrentDateGroup == 'Week') &&
                    data.column.dataField == 'TxnDate'
                "
              >
                <gc-friendly-date :date="getDateString(data)" />
              </div>
              <div class="informer" v-else>
                <span>{{ getDateString(data) }}</span>
              </div>
            </template>

            <template #dategroupdisplay-cell-template="{ data }">
              <div>
                <gc-friendly-date :date="data.data.DateGroupDisplay" />
              </div>
            </template>

            <template #number-cell-template="{ data }">
              <div>
                <span v-if="data.value < 0" class="avail-error">{{
                  "(" + data.text.replace(/[-]/, "") + ")"
                }}</span>
                <span v-if="data.value > 0">{{ data.text }}</span>
                <span v-if="data.value == 0">{{ "-" }}</span>
              </div>
            </template>
          </dx-data-grid>
        </template>

        <template #rightContent>
          <gc-advance-filter-panel
            :toolbar="filterToolbar"
            :filterFormHeight="filterFormHeight"
            :advanceFilterArray="advanceFilterArray"
            :filterCallBack="createFilterArray"
            :sideBarTabs="sideBarTabs"
            :filterFormItems="filterFormItems"
            :filterModel="getAdvanceFilterModel"
            :isJson="false"
            :screenType="'invoice-sales'"
            :applyFilter="applyFilter"
          >
          </gc-advance-filter-panel>
        </template>
      </gc-filter-split-view>
    </div>
  </gc-main-layout>
</template>

<script>
import BaseViewMixin from "../../v1/_mixins/base.view";
import { GridReportService } from "../../_services/api/reports/grid-report.service";
import {
  DxSummary,
  DxGroupItem,
  DxExport,
  DxGrouping,
  DxGroupPanel,
} from "devextreme-vue/data-grid";

export default {
  props: {},
  mixins: [BaseViewMixin],
  components: {
    DxExport,
    DxGrouping,
    DxSummary,
    DxGroupItem,
    DxGroupPanel,
  },
  data() {
    return {
      advanceFilterArray: [],
      serverSideFilter: [],
      jsonData: undefined,
      jSonDataItems: undefined,
      reportTitle: "Outstanding Sales Order",
      dataSourceConfig: [],
      showLeftContainer: true,
      showRightContainer: true,
      filterToolbar: {
        close: {
          icon: "showpanel",
          onClick: () => {
            this.showRightContainer = !this.showRightContainer;
            var item = document.getElementById("filter-btn");
            item.classList.remove("dx-state-invisible");
          },
        },
      },
      filterFormHeight: "auto",
      sideBarTabs: [
        {
          id: 0,
          text: "Filters",
        },
      ],
      saveFileName: "Outstanding Sales Orders",
      filterByDate: false,
      apiRouteUrl: {
        url: "api/ReportOutstandingSalesOrderDetail",
        filter: [["BranchCode", "=", "01"], "and", ["OrderStatus", "=", "A"]],
        // top: 50
      },
      loaded: false,
      //   columnSummary: undefined,
      advanceFilterModel: {
        BranchCode: ["01"],
        OrderStatus: ["A"],
        SalesRepresentativeCode: [],
        CustomerSalesRepresentativeCode: [],
      },
      model: {
        StartWeekDisplay: undefined,
        CurrentDateGroup: undefined,
      },
      applyServerFilter: true,
    };
  },
  async created() {
    this.showLoading(true);
    await this.getDefaultValue();
    this.getReportData([]);
  },
  methods: {
    getDateString(value) {
      let groupValue = null;
      let data = value.displayValue.match(/.{1,2}/g);
      if (
        this.model.CurrentDateGroup == "Day" ||
        this.model.CurrentDateGroup == "Week"
      ) {
        if (data.length == 4)
          groupValue = new Date(
            data[0].concat(data[1]) + "-" + data[2] + "-" + data[3]
          );
      } else if (this.model.CurrentDateGroup == "Month") {
        if (data.length == 3)
          groupValue = new Date(
            data[0].concat(data[1]) + "-" + data[2] + "-01"
          ).toShortMonthString();
      }

      return groupValue ? groupValue : value.displayValue;
    },
    async getDefaultValue() {
      this.advanceFilterModel.BranchCode = ["01"];
      this.advanceFilterModel.OrderStatus = ["A"];

      this.advanceFilterArray = [];
      this.serverSideFilter = [];
      this.serverSideFilter.push([
        ["BranchCode", "=", "01"],
        "and",
        ["OrderStatus", "=", "A"],
      ]);

      // await this.setDateFilter(new Date(), "TxnDate");
    },
    async setDateFilter(value, variable) {
      this.serverSideFilter = [];
      let date = new Date(value).toYYYYMMDD();
      let nextDate = new Date(
        new Date(value).getTime() + 1 * 24 * 60 * 60 * 1000
      ).toYYYYMMDD();

      let afilter = [
        [`${variable}`, ">=", new Date(date + "T00:00:00")],
        "and",
        [`${variable}`, "<", new Date(nextDate + "T00:00:00")],
      ];
      this.serverSideFilter.push(afilter);
    },

    async getReportData(filterCollection) {
      let ds = GridReportService.dataSourceConfig(this.apiRouteUrl["url"], {
        count: true,
        preventPagination: true,
        filter: this.serverSideFilter,
      });
      if (this.applyServerFilter) {
        this.loadingCompleted = false;
        await ds.load();
        this.dataSourceConfig = ds.items();
        this.applyServerFilter = false;
      }

      if (this.$refs["grid-report-grid"]) {
        let grid = this.$refs["grid-report-grid"].instance;
        if (filterCollection.length != 0) {
          grid.filter(filterCollection);
          grid.refresh(true);
        } else {
          grid.clearFilter();
          grid.refresh(true);
        }
      }
      this.showLoading(false);
      this.loadingCompleted = true;

      this.model.CurrentDateGroup = this.advanceFilterModel.DateGroup;
    },
    listContentReady(e) {
      this.filterFormHeight =
        document.getElementsByClassName("dx-datagrid dx-gridbase-container")[0]
          .clientHeight -
        document.getElementsByClassName("dx-datagrid-header-panel")[0]
          .clientHeight -
        30;

      this.addGridNoResults(e);
    },
    async createFilterArray(filterCollection, filterField, e) {
      if (filterField == "TxnDate") {
        this.applyServerFilter = true;
        await this.setDateFilter(e.value, "TxnDate");
      } else {
        if (
          filterCollection.length == 0 &&
          filterField != "DateGroup" &&
          filterField == undefined
        ) {
          await this.getDefaultValue();
        } else {
          this.showLoading(false);
        }
      }
    },
    async applyFilter(type, filterCollection) {
      // eslint-disable-next-line no-console
      console.log("Filter Collection", filterCollection);

      this.showLoading(true);
      this.applyServerFilter = true;
      if (type == "clear") {
        await this.getDefaultValue();
      }
      this.getReportData(filterCollection);
    },
    onToolbarPreparing(e) {
      var toolbarItems = e.toolbarOptions.items;
      var searchPanel = toolbarItems.find((item) => {
        return item.name === "searchPanel";
      });
      var exportButton = toolbarItems.find((item) => {
        return item.name === "exportButton";
      });
      var columnChooserButton = toolbarItems.find((item) => {
        return item.name === "columnChooserButton";
      });
      e.toolbarOptions.items = toolbarItems.filter((item) => {
        return (
          item.name !== "searchPanel" &&
          item.name !== "exportButton" &&
          item.name !== "columnChooserButton"
        );
      });
      searchPanel.location = "after";
      e.toolbarOptions.items.unshift(
        searchPanel,
        exportButton,
        columnChooserButton,
        {
          location: "after",
          locateinmenu: "auto",
          widget: "dxButton",
          options: {
            validationGroup: "formsData",
            icon: "filter",
            elementAttr: { id: "filter-btn" },
            onClick: () => {
              this.showRightContainer = !this.showRightContainer;
              var item = document.getElementById("filter-btn");
              this.$logger.debug("item ", item);
              item.classList.add("dx-state-invisible");
            },
          },
        }
      );
    },
    backButtonFunction() {
      this.$router.push({
        path: "/reports/sales",
      });
    },
    setWeekStartDate(e) {
      this.model.StartWeekDisplay = e.itemData.StartWeekDisplay;
      this.setWeekFilter();
    },
  },
  computed: {
    getAdvanceFilterModel() {
      return this.advanceFilterModel;
    },
    filterFormItems() {
      return [
        {
          itemType: "group",
          caption: "",
          colCount: 1,
          items: this.parseFormColumns([
            {
              dataField: "TxnDate",
              gcType: "Date",
              editorType: "DxDateBox",
              gcLabel: "Date In",
              editorOptions: {
                editorType: "DxDateBox",
                filterCode: "TxnDate",
              },
            },
            {
              dataField: "RequiredDate",
              gcType: "Date",
              editorType: "DxDateBox",
              gcLabel: "Reqd Date",
              editorOptions: {
                editorType: "DxDateBox",
                filterCode: "RequiredDate",
              },
            },
            {
              dataField: "ShipDate",
              gcType: "Date",
              editorType: "DxDateBox",
              gcLabel: "Ship Date",
              editorOptions: {
                editorType: "DxDateBox",
                filterCode: "ShipDate",
              },
            },

            {
              dataField: "BranchCode",
              gcType: "String",
              editorType: "dxTagBox",
              gcLabel: "Branch",
              editorOptions: {
                dataSource: GridReportService.dataSourceConfig("api/Branch", {
                  filter: [["Inactive", "=", "N"]],
                  sort: [{ selector: "Description", asc: true }],
                }),
                valueExpr: "Code",
                displayExpr: "Description",
                searchExpr: ["Code", "Description"],
                searchMode: "contains",
                searchEnabled: true,
                itemTemplate: "item-template",
              },
            },
            {
              dataField: "ItemCode",
              gcType: "String",
              editorType: "dxTagBox",
              gcLabel: "Items",
              editorOptions: {
                dataSource: GridReportService.dataSourceConfig(
                  "api/ProductList",
                  {
                    filter: [["Inactive", "=", "N"]],
                    sort: [{ selector: "Description1", asc: true }],
                  }
                ),
                valueExpr: "Code",
                displayExpr: "Description1",
                searchExpr: ["Code", "Description1"],
                searchMode: "contains",
                searchEnabled: true,
                itemTemplate: "product-item-template",
              },
            },
            {
              dataField: "ProdCat2Code",
              gcType: "String",
              editorType: "dxTagBox",
              gcLabel: "Product Category 2",
              editorOptions: {
                dataSource: GridReportService.dataSourceConfig(
                  "api/ProductCategory2",
                  {
                    filter: [["Inactive", "=", "N"]],
                    sort: [{ selector: "Description", asc: true }],
                  }
                ),
                valueExpr: "Code",
                displayExpr: "Description",
                searchExpr: ["Code", "Description"],
                searchMode: "contains",
                searchEnabled: true,
                itemTemplate: "item-template",
              },
            },
            {
              dataField: "CustomerCode",
              gcType: "String",
              editorType: "dxTagBox",
              gcLabel: "Customer",
              editorOptions: {
                dataSource: GridReportService.dataSourceConfig("api/Customer", {
                  filter: [["Inactive", "=", "N"]],
                  sort: [{ selector: "Name", asc: true }],
                }),
                valueExpr: "Code",
                displayExpr: "Name",
                searchExpr: ["Code", "Name"],
                searchMode: "contains",
                searchEnabled: true,
                itemTemplate: "sub-code-template",
              },
            },
            {
              dataField: "CustomerSalesRepCode",
              gcType: "String",
              editorType: "dxTagBox",
              gcLabel: "Customer Rep",
              editorOptions: {
                dataSource: GridReportService.dataSourceConfig(
                  "api/SalesRepresentative",
                  {
                    select: ["Code", "FirstName", "Surname"],
                    filter: [
                      ["Inactive", "=", "N"],
                      ["Status", "=", "A"],
                    ],
                  }
                ),
                valueExpr: "Code",
                displayExpr: function(data) {
                  if (data) return data.FirstName + " " + data.Surname;
                },
                searchMode: "contains",
                itemTemplate: "rep-item-template",
                searchEnabled: true,
              },
            },
            {
              dataField: "SalesOrderCode",
              gcType: "String",
              editorType: "dxTagBox",
              gcLabel: "Sales Order",
              editorOptions: {
                dataSource: GridReportService.dataSourceConfig(
                  "api/SalesOrder",
                  {
                    select: ["Code"],
                    sort: [{ selector: "Code", desc: true }],
                  }
                ),
                valueExpr: "Code",
                displayExpr: "Code",
                searchExpr: ["Code"],
                searchEnabled: true,
              },
            },
            {
              dataField: "OrderStatus",
              gcLabel: "Status",
              gcType: "String",
              editorType: "dxTagBox",
              editorOptions: {
                items: [
                  { text: "Active", value: "A" },
                  { text: "Draft", value: "D" },
                  { text: "Completed", value: "C" },
                  { text: "Cancelled", value: "X" },
                ],
                valueExpr: "value",
                displayExpr: "text",
                filterCode: "OrderStatus",
              },
            },
          ]),
        },
      ];
    },
    columnSummary() {
      return [];
    },

    columns() {
      return this.parseGridColumns("master", [
        {
          gcLabel: "Customer",
          dataField: "CustomerName",
          gcType: "String",
          width: 220,
          sortOrder: "asc",
          cellTemplate: "customer-cell-template",
          groupCellTemplate: "groupHeaderTemplate",
        },
        {
          gcLabel: "Item",
          dataField: "ItemDescription1",
          gcType: "String",
          width: 220,
          sortOrder: "asc",
          cellTemplate: "item-cell-template",
          groupCellTemplate: "groupHeaderTemplate",
        },
        {
          gcLabel: "Ship Date",
          dataField: "ShipDate",
          gcType: "Date",
          sortOrder: "asc",
          groupCellTemplate: "groupHeaderTemplate",
        },
        {
          gcLabel: "Sales UM Order Qty",
          dataField: "SalesUMOrderQty",
          gcType: "Decimal-4-2",
          groupCellTemplate: "groupHeaderTemplate",
          cellTemplate: "number-cell-template",
        },
        {
          gcLabel: "Sale UM Picked Qty",
          dataField: "SalesUMPickedQty",
          gcType: "Decimal-4-2",
          groupCellTemplate: "groupHeaderTemplate",
          cellTemplate: "number-cell-template",
        },
        {
          gcLabel: "Sales UM Back Order Qty",
          dataField: "SalesUMBackOrderQty",
          gcType: "Decimal-4-2",
          groupCellTemplate: "groupHeaderTemplate",
          cellTemplate: "number-cell-template",
        },
        {
          gcLabel: "Taxable Line Total",
          dataField: "TaxableLineTotal",
          gcType: "Decimal-4-2C",
          allowResizing: false,
          groupCellTemplate: "groupHeaderTemplate",
          cellTemplate: "number-cell-template",
        },
        {
          gcLabel: "Taxable Back Order Line Total",
          dataField: "TaxableBackOrderLineTotal",
          gcType: "Decimal-4-2C",
          allowResizing: false,
          groupCellTemplate: "groupHeaderTemplate",
          cellTemplate: "number-cell-template",
        },
        {
          gcLabel: "Status",
          dataField: "OrderStatus",
          gcType: "String",
          width: 100,
        },
        {
          gcLabel: "Line Total",
          dataField: "LineTotal",
          gcType: "Decimal-4-2C",
          gcSubType: "HiddenCode",
          allowResizing: false,
          groupCellTemplate: "groupHeaderTemplate",
          cellTemplate: "number-cell-template",
        },
        {
          gcLabel: "Date In",
          dataField: "TxnDate",
          gcType: "Date",
          gcSubType: "PrimaryDate",
          sortOrder: "asc",
          allowHiding: false,
          groupIndex: "0",
          groupCellTemplate: "groupHeaderTemplate",
        },

        {
          gcLabel: "Reqd Date",
          dataField: "RequiredDate",
          gcType: "Date",
          sortOrder: "asc",
          groupCellTemplate: "groupHeaderTemplate",
        },

        {
          gcLabel: "Branch",
          dataField: "BranchName",
          gcType: "String",
          width: 220,
          cellTemplate: "branch-cell-template",
          gcSubType: "HiddenDescription",
          groupCellTemplate: "groupHeaderTemplate",
        },

        {
          gcLabel: "Category 1",
          dataField: "ProdCat1Name",
          gcType: "String",
          width: 220,
          cellTemplate: "category-1-cell-template",
          groupCellTemplate: "groupHeaderTemplate",
        },
        {
          gcLabel: "Category 2",
          dataField: "ProdCat2Name",
          gcType: "String",
          width: 220,

          cellTemplate: "category-2-cell-template",
          groupCellTemplate: "groupHeaderTemplate",
        },
        {
          gcLabel: "Category 3",
          dataField: "ProdCat3Name",
          gcType: "String",
          width: 220,
          cellTemplate: "category-3-cell-template",
          groupCellTemplate: "groupHeaderTemplate",
        },
        {
          gcLabel: "Category 4",
          dataField: "ProdCat4Name",
          gcType: "String",
          width: 220,
          cellTemplate: "category-4-cell-template",
          groupCellTemplate: "groupHeaderTemplate",
        },
        {
          gcLabel: "Product Type",
          dataField: "ProdTypeName",
          gcType: "String",
          width: 220,
          cellTemplate: "product-type-cell-template",
          groupCellTemplate: "groupHeaderTemplate",
        },

        {
          gcLabel: "Sales Rep",
          dataField: "SalesRepresentativeCode",
          width: 200,
          gcType: "String",
          cellTemplate: "sales-rep-cell-template",
          gcSubType: "HiddenDescription",
          groupCellTemplate: "groupHeaderTemplate",
        },

        {
          gcLabel: "Drop Code",
          dataField: "DropName",
          width: 200,
          gcType: "String",
          cellTemplate: "drop-code-cell-template",
          gcSubType: "HiddenDescription",
          groupCellTemplate: "groupHeaderTemplate",
        },
        {
          gcLabel: "Division",
          dataField: "DivisionName",
          gcType: "String",
          width: 220,
          cellTemplate: "division-cell-template",
          gcSubType: "HiddenDescription",
          groupCellTemplate: "groupHeaderTemplate",
        },
        {
          gcLabel: "Customer PO",
          dataField: "CustomerPO",
          gcType: "String",
          sortOrder: "asc",
          width: 120,
          gcSubType: "HiddenDescription",
          groupCellTemplate: "groupHeaderTemplate",
        },

        {
          gcLabel: "Sales Order Code",
          dataField: "SalesOrderCode",
          gcType: "String",
          width: 120,
          //   gcSubType: "HiddenDescription",
          //   groupCellTemplate: "groupHeaderTemplate",
          groupIndex: "1",
        },
        {
          gcLabel: "Sales Order Line",
          dataField: "SalesOrderLine",
          gcType: "String",
          width: 80,
          gcSubType: "HiddenDescription",
          groupCellTemplate: "groupHeaderTemplate",
        },

        {
          gcLabel: "Customer Group",
          dataField: "CustomerGroupDescription",
          gcType: "String",
          width: 220,
          sortOrder: "asc",
          cellTemplate: "customer-group-cell-template",
          groupCellTemplate: "groupHeaderTemplate",
        },
        {
          gcLabel: "Customer Type",
          dataField: "CustomerTypeDescription",
          gcType: "String",
          minWidth: 300,
          cellTemplate: "customer-type-cell-template",
          gcSubType: "HiddenDescription",
          groupCellTemplate: "groupHeaderTemplate",
        },

        {
          gcLabel: "Customer Rep",
          dataField: "CustomerSalesRepresentativeCode",
          width: 200,
          gcType: "String",
          cellTemplate: "customer-rep-cell-template",
          gcSubType: "HiddenDescription",
          groupCellTemplate: "groupHeaderTemplate",
        },

        {
          gcLabel: "Stock UM Order Qty",
          dataField: "StockUMOrderQty",
          gcType: "Decimal-4-2",
          groupCellTemplate: "groupHeaderTemplate",
          cellTemplate: "number-cell-template",
        },
        {
          gcLabel: "Stock UM Picked Qty",
          dataField: "StockUMPickedQty",
          gcType: "Decimal-4-2",
          groupCellTemplate: "groupHeaderTemplate",
          cellTemplate: "number-cell-template",
        },
        {
          gcLabel: "Stock UM Back Order Qty",
          dataField: "StockUMBackOrderQty",
          gcType: "Decimal-4-2",
          groupCellTemplate: "groupHeaderTemplate",
          cellTemplate: "number-cell-template",
        },

        {
          gcLabel: "Sales Rep Code",
          dataField: "SalesRepresentativeCode",
          width: 150,
          gcType: "String",
          gcSubType: "HiddenDescription",
          groupCellTemplate: "groupHeaderTemplate",
        },
        {
          gcLabel: "Sales Rep Name",
          dataField: "SalesRepresentativeFullName",
          width: 200,
          gcType: "String",
          gcSubType: "HiddenDescription",
          groupCellTemplate: "groupHeaderTemplate",
        },
        {
          gcLabel: "Customer Rep Code",
          dataField: "CustomerSalesRepresentativeCode",
          width: 150,
          gcType: "String",
          gcSubType: "HiddenDescription",
          groupCellTemplate: "groupHeaderTemplate",
        },
        {
          gcLabel: "Customer Rep Name",
          dataField: "CustomerSalesRepresentativeFullName",
          width: 200,
          gcType: "String",
          gcSubType: "HiddenDescription",
          groupCellTemplate: "groupHeaderTemplate",
        },
        {
          gcLabel: "Customer Group Code",
          dataField: "CustomerGroupCode",
          width: 200,
          gcType: "String",
          gcSubType: "HiddenDescription",
          groupCellTemplate: "groupHeaderTemplate",
        },
        {
          gcLabel: "Customer Group Description",
          dataField: "CustomerGroupDescription",
          width: 200,
          gcType: "String",
          gcSubType: "HiddenDescription",
          groupCellTemplate: "groupHeaderTemplate",
        },
        {
          gcLabel: "Customer Type Code",
          dataField: "CustomerTypeCode",
          width: 200,
          gcType: "String",
          gcSubType: "HiddenDescription",
          groupCellTemplate: "groupHeaderTemplate",
        },
        {
          gcLabel: "Customer Type Description",
          dataField: "CustomerTypeDescription",
          width: 200,
          gcType: "String",
          gcSubType: "HiddenDescription",
          groupCellTemplate: "groupHeaderTemplate",
        },
        {
          gcLabel: "Customer Code",
          dataField: "CustomerCode",
          width: 200,
          gcType: "String",
          gcSubType: "HiddenDescription",
          groupCellTemplate: "groupHeaderTemplate",
        },
        {
          gcLabel: "Customer Name",
          dataField: "CustomerName",
          width: 200,
          gcType: "String",
          gcSubType: "HiddenDescription",
          groupCellTemplate: "groupHeaderTemplate",
        },
        {
          gcLabel: "Branch Code",
          dataField: "BranchCode",
          width: 200,
          gcType: "String",
          gcSubType: "HiddenDescription",
          groupCellTemplate: "groupHeaderTemplate",
        },
        {
          gcLabel: "Branch Name",
          dataField: "BranchName",
          width: 200,
          gcType: "String",
          gcSubType: "HiddenDescription",
          groupCellTemplate: "groupHeaderTemplate",
        },
        {
          gcLabel: "Category 1 Code",
          dataField: "ProdCat1Code",
          width: 200,
          gcType: "String",
          gcSubType: "HiddenDescription",
          groupCellTemplate: "groupHeaderTemplate",
        },
        {
          gcLabel: "Category 1 Description",
          dataField: "ProdCat1Name",
          width: 200,
          gcType: "String",
          gcSubType: "HiddenDescription",
          groupCellTemplate: "groupHeaderTemplate",
        },
        {
          gcLabel: "Category 2 Code",
          dataField: "ProdCat2Code",
          width: 200,
          gcType: "String",
          gcSubType: "HiddenDescription",
          groupCellTemplate: "groupHeaderTemplate",
        },
        {
          gcLabel: "Category 2 Description",
          dataField: "ProdCat2Name",
          width: 200,
          gcType: "String",
          gcSubType: "HiddenDescription",
          groupCellTemplate: "groupHeaderTemplate",
        },
        {
          gcLabel: "Category 3 Code",
          dataField: "ProdCat3Code",
          width: 200,
          gcType: "String",
          gcSubType: "HiddenDescription",
          groupCellTemplate: "groupHeaderTemplate",
        },
        {
          gcLabel: "Category 3 Description",
          dataField: "ProdCat3Name",
          width: 200,
          gcType: "String",
          gcSubType: "HiddenDescription",
          groupCellTemplate: "groupHeaderTemplate",
        },
        {
          gcLabel: "Category 4 Code",
          dataField: "ProdCat4Code",
          width: 200,
          gcType: "String",
          gcSubType: "HiddenDescription",
          groupCellTemplate: "groupHeaderTemplate",
        },
        {
          gcLabel: "Category 4 Description",
          dataField: "ProdCat4Name",
          width: 200,
          gcType: "String",
          gcSubType: "HiddenDescription",
          groupCellTemplate: "groupHeaderTemplate",
        },
        {
          gcLabel: "Product Type Code",
          dataField: "ProdTypeCode",
          width: 200,
          gcType: "String",
          gcSubType: "HiddenDescription",
          groupCellTemplate: "groupHeaderTemplate",
        },
        {
          gcLabel: "Product Type Description",
          dataField: "ProdTypeName",
          width: 200,
          gcType: "String",
          gcSubType: "HiddenDescription",
          groupCellTemplate: "groupHeaderTemplate",
        },

        {
          gcLabel: "Item Code",
          dataField: "ItemCode",
          width: 200,
          gcType: "String",
          gcSubType: "HiddenDescription",
          groupCellTemplate: "groupHeaderTemplate",
        },
        {
          gcLabel: "Item Description",
          dataField: "ItemName1",
          width: 200,
          gcType: "String",
          gcSubType: "HiddenDescription",
          groupCellTemplate: "groupHeaderTemplate",
        },
        {
          gcLabel: "",
          dataField: "",
          width: 5,
          minWidth: 5,
          gcType: "String",
          allowResizing: false,
          columnMinWidth: 5,
          fixed: true,
          fixedPosition: "right",
          allowExporting: false,
          allowGrouping: false,
          allowHiding: false,
          showInColumnChooser: false,
        },
      ]);
    },
  },
};
</script>
